/* ==========================================================================
 * DIVEIN — 购物车折扣展示补丁  (v3)
 * --------------------------------------------------------------------------
 * 【v3 要做的两件事】
 *   ① 把右栏的折扣展示换成我们自己的「省了多少」卡片（品牌红卡片 + 明细 + 合计）
 *   ② 把主题原生的 Coupon 输入框区块整个隐去
 *      —— 后台是「自动折扣」，客人不需要输 CODE，留在那里反而让人以为
 *         还没拿到优惠，白白多一个输入框。
 *
 * 【顺便修掉的 bug（v2 已在做）】
 *   购物车页 (/cart) 改商品数量后，「You save in total」和折扣明细金额不刷新。
 *
 *   根因：
 *     sections/main-cart.liquid 用 Liquid 服务端渲染折扣明细
 *       <li class="discounts__discount" data-discount="{{ discount.total_allocated_amount }}">
 *     assets/jquery.interact-function.js.liquid 的 saveTotal() 只把 DOM 里
 *       **已经存在**的 .discounts__discount[data-discount] 加起来，从不回后端取数。
 *     而「改数量」走 POST /cart/change，主题只请求 sections:['minicart']，
 *       主购物车区块根本不重渲染 → 数字冻结。
 *     （对照：加购 ajax:addToCart 会重拉主区块，所以加购时数字是对的。）
 *
 *   修法：拿到最新 cart JSON → ① 重建主题原生折扣列表（换掉元素本身，
 *     因为 jQuery 的 .data() 会缓存 data-*，只改属性读到的还是旧值）
 *     ② 同步渲染我们自己的卡片数字。
 *
 * 【本补丁不改动主题任何原有文件】
 *   安装：Assets 新建 divein-cart-discount.js → theme.liquid 的 </body> 前加
 *        {{ 'divein-cart-discount.js' | asset_url | script_tag }}
 *        删掉那行即完全回滚。
 *
 * 配套样式：divein-cart-discount.css（同一套装法，挂 </head> 前）
 * ========================================================================== */
(function () {
  'use strict';

  if (window.__dvCartDiscount) return;
  window.__dvCartDiscount = true;

  /* ===================== 可调参数 ===================== */
  var CFG = {
    /* ---------- ① 折扣卡片 ---------- */
    savingsCard: {
      /* 卡片标题（客人看得到） */
      title: 'Discount applied',
      /* 标题下面那句小字：说明「不用输码」 */
      note: 'Applied automatically — no code needed',
      /* 合计那行的标签 */
      totalLabel: 'You save in total',
      /* 单品级差价省额的行标题（商品有 compare_at 时会出现） */
      itemSavingLabel: 'Product savings'
    },

    /* ---------- ② 隐去主题原生的 Coupon 区块 ---------- */
    hideCouponBlock: true,
    /* 主题原生那两行（折扣明细 / You save in total）也一并隐去，
       免得跟我们的卡片重复显示 */
    hideThemeDiscountBlocks: true,

    /* ---------- 免运费提示口径 ---------- */
    /* 'always'    → 后台是「全场免运费」时用
       'threshold' → 后台是「满 X 免运费」时用，配合下方门槛（分）
       'theme'     → 完全不干预，沿用主题自己的逻辑 */
    freeShippingMode: 'always',
    freeShippingThreshold: 50000,                 /* 分。50000 = HKD 500 */
    freeShippingText: 'Free shipping applied to every order',
    freeShippingNeedText: 'Spend {amount} more to get free shipping',

    /* ---------- 迷你购物车 ---------- */
    fixMiniCartLabel: true,
    miniSubtotalLabel: 'Subtotal',
    miniTotalLabel: 'Total',

    /* ---------- 折扣标题映射 ---------- */
    /* 后台折扣名是中文时，这里换成英文给客人看。
       格式： '后台折扣标题': '前台显示文字'
       没匹配到的原样显示后台标题。
       ※ 更省事：直接在 Shopify 后台把折扣名字起成英文，这张表就不用填。 */
    titleMap: {
      '全场95折': '5% off every order',
      '满5000享9折': '10% off orders over HKD 5,000',
      '免运费': 'Free shipping',
      '5% off every order': '5% off every order',
      '10% off orders over HKD 5,000': '10% off orders over HKD 5,000',
      'Free shipping': 'Free shipping'
    },

    /* 调试：改成 true 会在 console 打印每次刷新的数据 */
    debug: false
  };
  /* =================== 可调参数结束 =================== */

  /* ---------- 小工具 ---------- */

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function mapTitle(t) {
    var s = t || '';
    if (CFG.titleMap && Object.prototype.hasOwnProperty.call(CFG.titleMap, s)) {
      return CFG.titleMap[s];
    }
    return s;
  }

  /* ---------- 金额格式化 ----------
   * ⚠ 多市场坑（本项目实测，2026-11）：
   *   1) /cart.js 返回的金额单位是「分」，币种 = 当前市场展示币种。
   *   2) Shopify.currency = {"active":"USD","rate":"0.1299939"}
   *      —— active 是字符串，不是对象，没有 .money_format 属性。
   *   3) Shopify.formatMoney(cents) 不传第二参会抛错。
   *   4) Shopify.currency.rate 是「店铺币种 → 展示币种」，
   *      展示币种 → 店铺币种 要 除以 rate。
   * 主题自己的做法是 Shopify.formatMoney(cents, theme.moneyFormat)，照抄即可。 */

  var MONEY_FMT = null;

  function presentmentFormat(code) {
    var fmt = null;
    try {
      if (window.Currency && window.Currency.moneyFormats && code &&
          window.Currency.moneyFormats[code]) {
        fmt = window.Currency.moneyFormats[code].money_format;
      }
    } catch (e) { /* ignore */ }
    if (!fmt) {
      try {
        if (window.theme && window.theme.moneyFormat) fmt = window.theme.moneyFormat;
      } catch (e) { /* ignore */ }
    }
    return fmt || '${{amount}}';
  }

  /* 兜底：自己实现 Shopify 的 money 格式串（万一主题没有 Shopify.formatMoney） */
  function fallbackMoney(cents, fmt) {
    var amount = (cents || 0) / 100;
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = String(fmt).match(re);
    if (!m) return String(fmt);

    var num;
    switch (m[1]) {
      case 'amount':
        num = amount.toFixed(2); break;
      case 'amount_no_decimals':
        num = amount.toFixed(0); break;
      case 'amount_with_comma_separator':
        num = amount.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); break;
      case 'amount_no_decimals_with_comma_separator':
        num = amount.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); break;
      default:
        num = amount.toFixed(2);
    }
    return String(fmt).replace(re, num);
  }

  /* 返回的是 HTML 字符串（可能含 &euro; 这类实体）→ 用 innerHTML 插入 */
  function money(cents) {
    var fmt = MONEY_FMT ||
      (window.theme && window.theme.moneyFormat) ||
      '${{amount}}';
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents || 0, fmt);
      }
    } catch (e) { /* fallthrough */ }
    return fallbackMoney(cents || 0, fmt);
  }

  /* ---------- 取购物车数据 ---------- */

  function fetchCart() {
    var url = root() + 'cart.js?_dv=' + Date.now();
    return fetch(url, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  /* 订单级折扣：两种 API 返回结构不一样，统一成一种
     cart/change 响应 → [{ amount, discount_application: { title, total_allocated_amount } }]
     /cart.js      → [{ title, total_allocated_amount }]（平铺） */
  function normalizeApps(raw) {
    var out = [];
    if (!raw || !raw.length) return out;
    for (var i = 0; i < raw.length; i++) {
      var a = raw[i] || {};
      var d = a.discount_application ? a.discount_application : a;
      if (!d) continue;
      var amt = (d.total_allocated_amount != null) ? d.total_allocated_amount
               : ((a.amount != null) ? a.amount : 0);
      out.push({
        title: mapTitle(d.title || ''),
        amount: amt || 0,
        targetType: d.target_type || ''
      });
    }
    return out;
  }

  /* 单品差价省额：主题 .ui-discount[data-total-save] 存的是「每件差价」，
     主题 saveTotal() 的口径是 × 当前数量。这里照抄同一口径。 */
  function lineSavingsFromDom() {
    var sum = 0;
    var nodes = document.querySelectorAll('.ui-discount[data-total-save]');
    for (var i = 0; i < nodes.length; i++) {
      var per = parseFloat(nodes[i].getAttribute('data-total-save'));
      if (!per) continue;
      var qty = 1;
      var row = nodes[i].closest ? (nodes[i].closest('.each-item') || nodes[i].closest('tr')) : null;
      if (row) {
        var q = row.querySelector('.js_qty');
        if (q) qty = parseFloat(q.value) || 1;
      }
      sum += per * qty;
    }
    return Math.round(sum);
  }

  /* 「You save in total」= 订单级折扣 + 单品差价省额（与主题 saveTotal() 同口径） */
  function calcTotalSave(cart, apps, hasApps) {
    var order = 0;
    if (hasApps) {
      for (var i = 0; i < apps.length; i++) order += apps[i].amount;
      return Math.round(order + lineSavingsFromDom());
    }
    /* 拿不到 apps（老 API）→ 直接用 total_discount，它已含单品级折扣 */
    return Math.round(cart.total_discount || 0);
  }

  /* ---------- ① 我们的「省了多少」卡片 ---------- */

  var BADGE_ICON =
    '<svg class="dv-savings__badge-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
    '<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" ' +
    'd="M8 0a8 8 0 100 16A8 8 0 008 0zm3.7 5.7a.9.9 0 010 1.3l-3.6 3.6a.9.9 0 01-1.3 0L4.7 8.4a.9.9 0 111.3-1.3l1.4 1.4 2.9-2.9a.9.9 0 011.4.1z"></path></svg>';

  /* 卡片里的每一行：名称 + 金额 */
  function cardRow(name, amount) {
    return '<li class="dv-savings__item">' +
             '<span class="dv-savings__name">' + escapeHtml(name) + '</span>' +
             '<span class="dv-savings__amt">-' + money(amount) + '</span>' +
           '</li>';
  }

  /* 生成卡片 HTML
     lines  : [{name, amount}] 明细行
     total  : 合计省额（>=0）
     mini   : 是否迷你购物车的紧凑版 */
  function cardHTML(lines, total, mini) {
    if (!lines.length && total <= 0) return '';

    var cls = 'dv-savings' + (mini ? ' dv-savings--mini' : '');

    var html = '<div class="' + cls + '" role="group" aria-label="' +
               escapeHtml(CFG.savingsCard.title) + '">';

    html += '<div class="dv-savings__head">' +
              '<span class="dv-savings__badge">' + BADGE_ICON +
              escapeHtml(CFG.savingsCard.title) + '</span>' +
              '<span class="dv-savings__note">' + escapeHtml(CFG.savingsCard.note) + '</span>' +
            '</div>';

    if (lines.length) {
      html += '<ul class="dv-savings__list">' +
              lines.map(function (l) { return cardRow(l.name, l.amount); }).join('') +
              '</ul>';
    }

    if (total > 0) {
      html += '<div class="dv-savings__foot">' +
                '<span class="dv-savings__foot-label">' +
                  escapeHtml(CFG.savingsCard.totalLabel) + '</span>' +
                '<span class="dv-savings__foot-amt">' + money(total) + '</span>' +
              '</div>';
    }

    html += '</div>';
    return html;
  }

  /* 渲染卡片到指定容器（插入到 anchor 之前）
     注意：外层固定用一个 .dv-savings-wrap 壳，避免「没有折扣时删掉卡片、
     下次又新建一个」导致壳越堆越多。 */
  function renderSavings(scope, anchor, lines, total, mini) {
    if (!scope) return;

    var html = cardHTML(lines, total, mini);
    var wrap = scope.querySelector('.dv-savings-wrap');

    if (!html) {
      /* 没有折扣 → 整个壳收掉（内层卡片也一起清掉，不留空壳） */
      if (wrap) wrap.innerHTML = '';
      return;
    }

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'dv-savings-wrap';
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(wrap, anchor);
      } else {
        scope.appendChild(wrap);
      }
    }
    if (wrap.innerHTML !== html) wrap.innerHTML = html;
  }

  /* ---------- ② 主题原生折扣列表（保留但隐去，兼容主题自己的 saveTotal） ---------- */

  /* 主题 snippets/icon-discount.liquid 的兜底图标 */
  var ICON_HTML = '<svg aria-hidden="true" focusable="false" role="presentation" ' +
    'class="icon icon-discount" viewBox="0 0 12 12">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" ' +
    'd="M7 0h3a2 2 0 012 2v3a2 2 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A2 2 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" ' +
    'fill="currentColor"></path></svg>';

  function updateDiscountList(scope, apps) {
    if (!scope) return;

    var box = scope.querySelector('.info-discount');

    if (!apps.length) {
      if (box) box.style.display = 'none';
      return;
    }

    if (!box) {
      box = document.createElement('div');
      box.className = 'info-checkout info-discount';
      var totalBox = scope.querySelector('.total-discount');
      var totalLine = scope.querySelector('.info-total');
      if (totalBox && totalBox.parentNode) {
        totalBox.parentNode.insertBefore(box, totalBox.nextSibling);
      } else if (totalLine && totalLine.parentNode) {
        totalLine.parentNode.insertBefore(box, totalLine);
      } else {
        scope.appendChild(box);
      }
    }
    box.style.display = '';

    var list = box.querySelector('ul.discounts');
    if (!list) {
      list = document.createElement('ul');
      list.className = 'discounts list-unstyled';
      list.setAttribute('role', 'list');
      list.setAttribute('aria-label', 'Discount');
      box.appendChild(list);
    }

    /* 图标优先沿用页面里已有的（保留主题的配色 class） */
    var existingIcon = list.querySelector('.discounts__discount svg');
    var iconHtml = existingIcon ? existingIcon.outerHTML : ICON_HTML;

    /* 整块重建 —— jQuery 的 .data() 会缓存 data-* 属性，
       换掉 <li> 元素本身，主题 saveTotal() 才读得到新值。 */
    var html = '';
    for (var i = 0; i < apps.length; i++) {
      html += '<li class="discounts__discount discounts__discount--position" data-discount="' +
              apps[i].amount + '">' + iconHtml +
              '\n ' + escapeHtml(apps[i].title) +
              '\n (-' + money(apps[i].amount) + ')' +
              '</li>';
    }
    if (list.innerHTML !== html) list.innerHTML = html;
  }

  /* ---------- 主题的「You save in total」（保留但隐去） ---------- */

  function updateTotalSave(scope, totalSave) {
    if (!scope) return;
    var box = scope.querySelector('.total-discount');
    if (!box) return;
    var val = box.querySelector('.total-save');

    if (totalSave > 0) {
      box.style.display = '';
      if (val) {
        var html = money(totalSave);
        if (val.innerHTML !== html) val.innerHTML = html;
      }
      box.setAttribute('data-total-save', String(totalSave));
    } else {
      box.style.display = 'none';
      if (val) val.innerHTML = money(0);
    }
  }

  /* ---------- 迷你购物车 ---------- */

  function updateMiniCart(cart, apps, totalSave, lineSaving) {
    var popup = document.getElementById('js_cart_popup');
    if (!popup) return;                       /* /cart 页没有迷你车 */
    var group = popup.querySelector('.cms-bottom-group');
    if (!group) return;

    /* 主题原生的折扣列表（我们隐去它，但仍然刷新数据，兼容主题逻辑） */
    updateDiscountList(group, apps);

    /* 我们的卡片：插在 Total 行之前 */
    var anchor = group.querySelector('.subtotal');
    var lines = apps.map(function (a) { return { name: a.title, amount: a.amount }; });
    if (!apps.length && lineSaving > 0) {
      lines.push({ name: CFG.savingsCard.itemSavingLabel, amount: lineSaving });
    }
    renderSavings(group, anchor, lines, totalSave, true);

    if (!CFG.fixMiniCartLabel) return;

    /* 主题那行标签写的是 cart.label.total = "Subtotal:"，
       但值填的是折后总额 total_price → 客人会以为小计就是折后价。
       这里改成 "Total:"，并在前面补一行真正的折前小计。 */
    if (!anchor) return;

    var label = anchor.querySelector('.text');
    if (label && label.textContent !== CFG.miniTotalLabel + ':') {
      label.textContent = CFG.miniTotalLabel + ':';
    }

    var sub = group.querySelector('.dv-cart-mini-subtotal');
    if (!sub) {
      sub = document.createElement('div');
      sub.className = 'dv-cart-mini-subtotal';
      sub.innerHTML = '<span class="text"></span><span class="dv-cart-mini-subtotal__val"></span>';
      anchor.parentNode.insertBefore(sub, anchor);
    }
    var subLabel = sub.querySelector('.text');
    if (subLabel && subLabel.textContent !== CFG.miniSubtotalLabel + ':') {
      subLabel.textContent = CFG.miniSubtotalLabel + ':';
    }
    var subVal = sub.querySelector('.dv-cart-mini-subtotal__val');
    if (subVal) {
      var html = money(cart.items_subtotal_price || 0);
      if (subVal.innerHTML !== html) subVal.innerHTML = html;
    }
  }

  /* ---------- 免运费提示改写 ---------- */
  /* 主题的 updateFreeShipping() 会用 data-value(=50000) 和折后总额算进度，
     并在 AJAX 之后重写 [data-js-text] 的 innerHTML。
     所以这里用 MutationObserver 盯着它，一旦被改写就立刻按实际口径纠正。 */

  /* 免运费门槛是按「店铺币种」设的，而购物车金额是「展示币种」。
     Shopify.currency.rate 是「店铺币种 → 展示币种」，
     所以「展示币种 → 店铺币种」要 除以 rate。 */
  function toShopCurrency(cents) {
    var rate = 1;
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
        rate = parseFloat(Shopify.currency.rate) || 1;
      }
    } catch (e) { /* ignore */ }
    if (!rate || rate === 1) return cents;
    return Math.round(cents / rate);
  }

  function writeFreeShipping(bar, base) {
    if (CFG.freeShippingMode === 'theme') return;

    var text = bar.querySelector('[data-js-text]');
    var progress = bar.querySelector('[data-js-progress]');
    if (!text) return;

    if (CFG.freeShippingMode === 'always') {
      if (text.innerHTML !== CFG.freeShippingText) text.innerHTML = CFG.freeShippingText;
      if (progress) progress.style.width = '100%';
      bar.classList.add('congratulations');
      bar.classList.remove('forward');
    } else {
      var remain = Math.max(CFG.freeShippingThreshold - base, 0);
      var html = remain > 0
        ? CFG.freeShippingNeedText.replace('{amount}', money(remain))
        : CFG.freeShippingText;
      if (text.innerHTML !== html) text.innerHTML = html;
      if (progress) {
        var pct = Math.min((base / CFG.freeShippingThreshold) * 100, 100);
        progress.style.width = pct.toFixed(1) + '%';
      }
      if (remain > 0) {
        bar.classList.remove('congratulations');
        bar.classList.add('forward');
      } else {
        bar.classList.add('congratulations');
        bar.classList.remove('forward');
      }
    }
  }

  var observedBars = [];
  function observeBar(bar) {
    if (observedBars.indexOf(bar) !== -1) return;
    observedBars.push(bar);

    var text = bar.querySelector('[data-js-text]');
    if (!text || !window.MutationObserver) return;

    new MutationObserver(function () {
      if (CFG.freeShippingMode === 'theme') return;
      /* writeFreeShipping 内部有「内容相同就不写」的保护，不会死循环 */
      writeFreeShipping(bar, bar.__dvBase || 0);
    }).observe(text, { childList: true, subtree: true, characterData: true });
  }

  function fixFreeShipping(cart) {
    if (CFG.freeShippingMode === 'theme') return;
    var bars = document.querySelectorAll('.js-free-shipping');
    if (!bars.length) return;

    /* 折前小计（items_subtotal_price）—— 免运费门槛通常按折前小计判定 */
    var base = toShopCurrency(cart.items_subtotal_price || cart.total_price || 0);

    for (var i = 0; i < bars.length; i++) {
      bars[i].__dvBase = base;
      writeFreeShipping(bars[i], base);
      observeBar(bars[i]);
    }
  }

  /* ---------- 主流程 ---------- */

  function applyCart(cart) {
    if (!cart) return;

    /* 存一份最近的 cart，供「主区块被主题重画后补回卡片」用 */
    lastCart = cart;

    /* 金额一律用「当前展示币种」的格式串来格式化 */
    MONEY_FMT = presentmentFormat(cart.currency);

    var raw = cart.cart_level_discount_applications;
    var hasApps = !!(raw && raw.length);
    var apps = normalizeApps(raw);
    var totalSave = calcTotalSave(cart, apps, hasApps);
    var lineSaving = lineSavingsFromDom();

    /* ---- 主购物车右栏 ---- */
    var mainScope = document.querySelector('.cart-right');
    if (mainScope) {
      /* 主题原生那两行（兼容主题逻辑 + 被 CSS 隐去） */
      updateDiscountList(mainScope, apps);
      updateTotalSave(mainScope, totalSave);

      /* 我们的卡片：插在 Order Totals 那一行之前 */
      var lines = apps.map(function (a) { return { name: a.title, amount: a.amount }; });
      if (!apps.length && lineSaving > 0) {
        lines.push({ name: CFG.savingsCard.itemSavingLabel, amount: lineSaving });
      }
      var anchor = mainScope.querySelector('.info-total');
      renderSavings(mainScope, anchor, lines, totalSave, false);
    }

    /* ---- 迷你购物车（/cart 页没有这个元素，跳过即可） ---- */
    updateMiniCart(cart, apps, totalSave, lineSaving);

    /* ---- 免运费提示 ---- */
    fixFreeShipping(cart);

    if (CFG.debug && window.console) {
      console.log('[DV cart-discount]', {
        apps: apps, totalSave: totalSave,
        total_price: cart.total_price,
        items_subtotal_price: cart.items_subtotal_price
      });
    }
  }

  var timer = null;
  function scheduleRefresh(delay) {
    if (!CFG.liveRefresh) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      refresh();
    }, delay == null ? 60 : delay);
  }

  function refresh() {
    fetchCart().then(applyCart).catch(function (e) {
      if (CFG.debug && window.console) console.warn('[DV cart-discount] refresh failed', e);
    });
  }

  /* 从事件里取出 cart JSON。
     主题的 cart/change 响应本身就是完整 cart 对象，直接用，省一次请求。
     但 update:miniCart 那条路塞的是 {sections:{minicart:"<html>"}} → 返回 null 走 /cart.js。 */
  function cartFromEvent(e) {
    var detail = e && e.detail;
    if (!detail) return null;
    var r = detail.response;
    if (r && typeof r === 'object' && typeof r.total_price === 'number') return r;
    return null;
  }

  function onCartEvent(e) {
    var cart = cartFromEvent(e);
    /* setTimeout(0)：确保主题自己的处理（重画迷你车 / saveTotal()）先跑完，
       我们再写数字，避免被主题的旧值覆盖。 */
    setTimeout(function () {
      if (cart) applyCart(cart);
      else refresh();
    }, 0);
  }

  /* ---------- 事件绑定 ---------- */

  function bind() {
    /* 主题的 drawer:Minicart：改数量 / 增删商品后都会触发，
       而且 detail.response 里就带着最新 cart JSON */
    document.addEventListener('drawer:Minicart', onCartEvent, false);

    /* 主题其它 Ajax 购物车事件 */
    if (window.jQuery) {
      jQuery(document.body).on(
        'ajax:addToCart ajax:updateCart ajax:deleteCart update:miniCart contentUpdated',
        onCartEvent
      );
    }

    /* 兜底：数量输入框变化（万一主题的请求失败，也要把数字刷对） */
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('js_qty')) {
        scheduleRefresh(400);
      }
    }, false);
  }

  /* ---------- 兜底：主购物车区块被主题整体重画后，把卡片补回去 ---------- */
  /* 主题的 ajax:addToCart 会重新拉整块主区块 HTML，我们的卡片会被冲掉。
     这里盯一下，发现卡片不见了就重新渲染（用最近一次拿到的 cart 数据）。 */
  var lastCart = null;

  function ensureCard() {
    if (!lastCart) return;
    var scope = document.querySelector('.cart-right');
    if (!scope) return;
    if (scope.querySelector('.dv-savings')) return;
    applyCart(lastCart);
  }

  function watchScope() {
    if (!window.MutationObserver) return;
    var scope = document.querySelector('.cart-right');
    if (!scope) return;
    new MutationObserver(function () {
      ensureCard();
    }).observe(scope, { childList: true, subtree: true });
  }

  function init() {
    bind();
    refresh().then(function () {
      watchScope();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
